import { useTranslation } from 'src/utils/i18n'
import { Icon } from '@iconify/react'
import { Input } from 'antd'
import { useState } from 'react'
import { androidWaKey } from 'src/@api/dashboard'
import { messageInfo } from '../Message'
import { gcloudDownload } from 'src/@api/login'

const { TextArea } = Input

const WhatsApp = () => {
  const { t } = useTranslation('androidLogin')
  const [phone, setPhone] = useState('')
  const [digitKey, setDigitKey] = useState('')

  const handleSubmit = async () => {
    const textWithoutSpaces = digitKey.replace(/\s/g, '') //格式化识别结果，去除空格
    if (phone == '') {
      messageInfo(t('Please enter the whatsapp number'))

      return
    }

    if (textWithoutSpaces?.length !== 64) {
      messageInfo(t('Please enter the correct key'))

      return
    }

    let username =
      JSON.parse(localStorage.getItem('DeviceUser')) != null
        ? JSON.parse(localStorage.getItem('DeviceUser')).username
        : ''

    let result = await androidWaKey({
      googleAccount: username,
      waAccount: phone,
      encryptionKey: textWithoutSpaces
    })
    if (result.data.ec === 0) {
      messageInfo(result.data.em)

      let download = await gcloudDownload({
        mode: 5,
        username: username
      })
      messageInfo(download.data.ed)
      localStorage.setItem('encryption-key', true)
    }
  }

  return (
    <div className='max-w-[600px] mx-auto pb-8'>
      <h2 className='text-[24px] text-[#282938] font-[600] mx-auto text-center'>{t('Back up WhatsApp')}</h2>
      <div>
        <p className='mt-[50px] flex'>
          <span>{t('Step1')}:</span>&nbsp;
          <span>
            <Icon icon='ph:dots-three-outline-vertical-fill' fontSize='1.5rem' style={{ display: 'initial' }} />
            &gt; {t('Settings')} &gt; {t('Chats')} &gt; {t('Chat backup')} &gt; {t('End-to-end encrypted backup')}.
          </span>
        </p>

        <p className='flex mt-[4px]'>
          <span className='font-[500]'>{t('Step2')}:</span>&ensp;
          <span>
            {t('Tap')}
            <span className='font-[600]'> {t('TURN ON')}.</span>
          </span>
        </p>

        <p className='flex mt-[4px]'>
          <span className='font-[500]'>{t('Step3')}:</span>&ensp;
          <span>
            {t('Tap')}
            <span className='font-[600]'> {t('Use a 64-digit encryption key instead')}.</span>
          </span>
        </p>

        <p className='flex mt-[4px]'>
          <span className='font-[500]'>{t('Step4')}:</span>&ensp;
          <span>
            {t('Tap')}
            <span className='font-[600]'> {t('Generate your 64digit key')}.</span>
          </span>
        </p>

        <p className='flex mt-[4px]'>
          <span className='font-[500]'>{t('Step5')}:</span>&ensp;
          <span>
            {t('Press and hold 64-digit key click')}
            <span className='font-[600]'> {t('Copy')}.</span>
          </span>
        </p>

        <p className='my-[14px]'>
          {t(
            'Then you can send the copy to your own phone or just take a picture and upload this one using the button below'
          )}
          .
        </p>

        <p className='flex'>
          <span className='font-[500]'>{t('Step6')}:</span>&ensp;
          <span>
            {t('Tap')}
            <span className='font-[600]'> {t('I Saved My 64digit key')}.</span>
          </span>
        </p>

        <p className='flex mt-[4px]'>
          <span className='font-[500]'>{t('Step7')}:</span>&ensp;
          <span>
            {t('Tap')}
            <span className='font-[600]'> {t('Create')} </span>
            {t('to complete')}.
          </span>
        </p>

        <p className='flex mt-[4px]'>
          <span className='font-[500]'>{t('Step8')}:</span>&ensp;
          <span>{t('Paste the 64digit key below and click submit')}.</span>
        </p>
      </div>

      <input
        className='mt-[30px] rounded-[10px] w-full h-[40px] bg-[#F7F8FA] outline-none text-[16px] px-[11px]'
        placeholder={t('WhatsApp number')}
        value={phone}
        onChange={e => {
          setPhone(e.target.value.trim())
        }}
      />

      <TextArea
        className='font-[600] mt-[16px] rounded-[10px] py-[10px] w-full bg-[#F7F8FA] border-0 h-[200px] text-[16px]'
        rows={4}
        placeholder={t('64-digit key')}
        value={digitKey}
        onChange={e => {
          setDigitKey(e.target.value.trim())
        }}
      />

      <button
        className='mt-[16px] w-full h-[48px] bg-[#FFCF55] rounded-[41px] text-[16px] text-[#1B1C2B]'
        onClick={() => handleSubmit()}
      >
        {t('Submit')}
      </button>
    </div>
  )
}

export default WhatsApp
